import { useCallback, useEffect, useState } from 'react';
import * as API from '../utils/API/API';
import { useQuery, useQueryClient } from 'react-query';

const User = API.user();

const QUERY_KEY = 'dbUser';

// Set the Stripe customer ID for the current user to be used by the Baremetrics script
const setBaremetricsCancelUserId = user => {
  const email = user?.email;
  const stripeCustomerId = user?.subscription?.customerId;
  window.baremetricsCancelUserId = stripeCustomerId || email;
};

const useCurrentUser = (queryOptions = {}) => {
  const queryClient = useQueryClient();

  const [currentUser, setCurrentUser] = useState(null);

  const currentUserQuery = useQuery([QUERY_KEY], () => User.getMe(), {
    refetchOnMount: false,
    staleTime: Infinity,
    ...queryOptions,
  });

  useEffect(() => {
    if (currentUserQuery.isSuccess && !currentUserQuery.isFetching && !currentUserQuery.isLoading) {
      const latestQueryUser = currentUserQuery?.data;
      setCurrentUser(userInState =>
        !userInState || userInState.user_user_id !== latestQueryUser?.user_user_id ? latestQueryUser : userInState
      );
      setBaremetricsCancelUserId(latestQueryUser);
    }
  }, [currentUserQuery?.data, currentUserQuery.isFetching, currentUserQuery.isLoading, currentUserQuery.isSuccess]);

  const onSet = (...args) => {
    setCurrentUser(...args);
    return queryClient.invalidateQueries([QUERY_KEY]);
  };

  const refetchUser = useCallback(() => currentUserQuery.refetch(), [currentUserQuery]);

  return [currentUser, onSet, currentUserQuery, refetchUser];
};

export default useCurrentUser;
